"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _generateLinks = require("../../utils/generateLinks");
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MobileMegaMenuPartialCategory = _ref => {
  let {
    name,
    link,
    closeDropDown,
    Link,
    isOpen
  } = _ref;
  const {
    mouse
  } = (0, _useMouse.default)();
  const linkObj = {
    url: link?.url,
    text: name
  };
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-mobile-mega-menu-category ${isOpen ? "" : "ter-mobile-mega-menu-category--hidden"}`
  }, /*#__PURE__*/_react.default.createElement("p", {
    // id={uniqueId("id-")}
    className: `ter-mobile-mega-menu-category__name--single`
  }, (0, _generateLinks.generateMobileLink)(linkObj, "ter-mobile-mega-menu-category__single-link", closeDropDown, mouse, Link, 2)));
};
var _default = MobileMegaMenuPartialCategory;
exports.default = _default;